import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: 'linear-gradient(180deg, #000000 0%, #0a0a0a 100%)',
      borderTop: '1px solid rgba(212, 175, 55, 0.2)',
      padding: '80px 40px 40px'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Main footer content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '60px',
          marginBottom: '60px'
        }}>
          {/* Company info */}
          <div>
            <div style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '32px',
              fontWeight: '700',
              color: '#D4AF37',
              letterSpacing: '2px',
              marginBottom: '20px'
            }}>
              SYSTEM
            </div>
            <p style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '15px',
              fontWeight: '300',
              color: '#CCCCCC',
              lineHeight: '1.8',
              marginBottom: '30px'
            }}>
              Desenvolvemos sites profissionais que transformam visitantes em clientes.
              Excelência digital para empreendedores visionarios.
            </p>
            <div style={{
              display: 'flex',
              gap: '15px'
            }}>
              {['instagram', 'linkedin', 'facebook'].map((social, idx) => (
                <a
                  key={idx}
                  href="#"
                  style={{
                    width: '40px',
                    height: '40px',
                    border: '1px solid rgba(212, 175, 55, 0.3)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#D4AF37',
                    textDecoration: 'none',
                    transition: 'background 0.3s ease, border-color 0.3s ease',
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '12px',
                    fontWeight: '600',
                    textTransform: 'uppercase'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(212, 175, 55, 0.2)';
                    e.currentTarget.style.borderColor = '#D4AF37';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.3)';
                  }}
                >
                  {social.charAt(0)}
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '20px',
              fontWeight: '600',
              color: '#FFFFFF',
              marginBottom: '25px'
            }}>
              Links Rápidos
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Serviços', 'Portfólio', 'Depoimentos', 'FAQ'].map((link, idx) => (
                <li key={idx} style={{ marginBottom: '15px' }}>
                  <button
                    onClick={() => {
                      const element = document.getElementById(link.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    style={{
                      background: 'none',
                      border: 'none',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: '15px',
                      fontWeight: '400',
                      color: '#CCCCCC',
                      transition: 'color 0.3s ease',
                      textAlign: 'left',
                      padding: 0
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#D4AF37'}
                    onMouseLeave={(e) => e.target.style.color = '#CCCCCC'}
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '20px',
              fontWeight: '600',
              color: '#FFFFFF',
              marginBottom: '25px'
            }}>
              Serviços
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {['Páginas de Vendas', 'Sites Institucionais', 'Manutenção Premium', 'Suporte Técnico'].map((service, idx) => (
                <li key={idx} style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '15px',
                  fontWeight: '400',
                  color: '#CCCCCC',
                  marginBottom: '15px'
                }}>
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: '20px',
              fontWeight: '600',
              color: '#FFFFFF',
              marginBottom: '25px'
            }}>
              Contato
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '20px'
              }}>
                <Phone size={18} color="#D4AF37" />
                <a
                  href="https://wa.me/5562995664918"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#CCCCCC',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#D4AF37'}
                  onMouseLeave={(e) => e.target.style.color = '#CCCCCC'}
                >
                  (62) 99566-4918
                </a>
              </li>
              <li style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '20px'
              }}>
                <Mail size={18} color="#D4AF37" />
                <span style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '15px',
                  fontWeight: '400',
                  color: '#CCCCCC'
                }}>
                  contato@system.com
                </span>
              </li>
              <li style={{
                display: 'flex',
                alignItems: 'start',
                gap: '12px'
              }}>
                <MapPin size={18} color="#D4AF37" style={{ marginTop: '2px' }} />
                <span style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '15px',
                  fontWeight: '400',
                  color: '#CCCCCC',
                  lineHeight: '1.6'
                }}>
                  Goiânia, GO<br />Brasil
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          paddingTop: '40px',
          borderTop: '1px solid rgba(212, 175, 55, 0.2)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <p style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '14px',
            fontWeight: '400',
            color: '#999999',
            margin: 0
          }}>
            © {currentYear} System. Todos os direitos reservados.
          </p>
          <div style={{ display: 'flex', gap: '30px' }}>
            {['Privacidade', 'Termos de Uso'].map((link, idx) => (
              <a
                key={idx}
                href="#"
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#999999',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#D4AF37'}
                onMouseLeave={(e) => e.target.style.color = '#999999'}
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          footer > div > div:first-child {
            grid-template-columns: 1fr !important;
          }
          footer > div > div:last-child {
            flex-direction: column;
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;